<template>
    <div class="file-preview form-control closed" disabled>
        <div>
            <i class="fa-solid fa-file-pdf icon"></i>
        </div>
        <div>
            <p class="font-weight-bold">{{ translationFile.title }}</p>
            <p class="text-muted" v-if="translationFile.size">{{ translationFile.size }}</p>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        translationFile: {
            type: Object,
            required: true,
        }
    }
}
</script>

<style scoped lang="scss">
.file-preview {
    display: flex;
    flex-direction: row;
    gap: 6px;
    align-items: center;
    margin-bottom: 5px;
    padding: 25px 8px !important;

    .icon {
        font-size: 18px;
        color: var(--blu-004583, #004583);
    }
}
</style>